import { Component, OnInit } from '@angular/core';
import { MdDialogRef } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { Bank } from '../../../agatextscreens/accounting/bank';
import { BankService } from '../../services/bank.service';

@Component({
  selector: 'app-deposit-cheque-dialog',
  templateUrl: './deposit-cheque-dialog.component.html',
  styleUrls: ['./deposit-cheque-dialog.component.scss'],
  providers: [BankService]
})
export class DepositChequeDialogComponent implements OnInit {
  bank_id: number;
  description: string;
  effective_date: string = new Date().toISOString().substr(0,10);
  total: string;

  items: any[];

  allBanks$: Observable<Bank[]>;

  constructor(private _dialogRef: MdDialogRef<DepositChequeDialogComponent>,
    private _bankService: BankService) { }

  ngOnInit() {
    this.allBanks$ = this._bankService.getBanks(true);
    this.total = this.items.reduce((a, b) => { return a * 1 + b.amount * 1 }, 0);
  }

  close(confirmed: boolean) {
    if (this.bank_id) {
      this._dialogRef.close(confirmed ? { cheques: this.items, bank_id: this.bank_id, description: this.description, effective_date: this.effective_date } : null)
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/shared/dialogs/deposit-cheque-dialog/deposit-cheque-dialog.component.ts